<template lang="pug">
  .researchExperience
    .text-block.one
      h4 How many people buy experience-based gifts? 
    .wine
      wineBottle
    .chart
      experiencePieChart
    .text-block.two(data-animate="true")
      .text-block-small.left-block
        p Gifts of experience such as a cooking class, spa treatment, membership for a wine club, or tickets to a sporting event have continued to be popular, with <span class="bold">39% of consumers</span> hoping to receive an experience gift and <span class="bold">23%</span> planning to give one.<span class="super"><a href="https://nrf.com/media-center/press-releases/young-adults-most-likely-spend-more-holiday-season" target="_blank">6</a></span>
      .text-block-small.right-block
        p Of those surveyed planned on buying some kind of experiential gift card, whether that be to a restaurant, a&nbspcoffee shop, or some form of entertainment, like a movie theater, in 2018, according to&nbspthe NRF.<span class="super"><a href="https://nrf.com/media-center/press-releases/young-adults-most-likely-spend-more-holiday-season" target="_blank">6</a></span>
    .people-bg
      people.desktop
      peopleMobile.mobile
</template>

<script>
import peopleMobile from '@/assets/img/svgs/experience-people-mobile.svg'
import wineBottle from '@/assets/img/svgs/wineBottle.svg'
import experiencePieChart from '@/assets/img/pieCharts/experienceBasedGifts.svg'
import people from '@/assets/img/svgs/experience-people.svg'
import AnimationManager from '../scripts/AnimationManager'

export default {
  name: 'researchExperience',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {   
    const stars = this.$el.querySelectorAll('.star')
    const chart = this.$el.querySelector('.pieChart')

    stars.forEach((star, i) => {
      const timeline = new TimelineLite({ paused: true })
        .from(star, .5, { transformOrigin: '50% 50%', opacity: 0, scale: .85, rotation: i%2 === 0 ? 30 : -30 }, i/2)
      AnimationManager.onEnterView(star, () => {
        timeline.seek(0)
        timeline.play()
      })
    })

    const pieChartsTimeline = new TimelineLite({ paused: true })
      .set(chart, {strokeDasharray:700})
      .fromTo(chart, 1.5, {strokeDashoffset:700, strokeDasharray:700}, { strokeDashoffset:0, ease: Power0.easeNone }, 0.5)

    AnimationManager.onEnterView(chart, () => {
      pieChartsTimeline.seek(0)
      pieChartsTimeline.play()
    })

  },
  computed: {
  },
  methods: {

  },
  components: {
    peopleMobile,
    wineBottle,
    experiencePieChart,
    people
  },
}
</script>

<style scoped lang="scss">
.researchExperience {
    position: relative;
    height: 66rem;
   .graphic-wrapper {
     padding-left: 18%;
   }
   h4 {
     color: #000;
   }
   .text-block {
     &.one {
       left: 18%;
       top: 10%;
     }

     &.two {
       left: 18%;
       top: 47%;
       width: 42%;
     }
   }

  .left-block {
    width:49%;
    margin-right: 6%;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      left: 100%;
      height: 16rem;
      top: 15%;
      margin-left: 1rem;
      width: .125rem;
      background-color: #3b7cf7;
    }
  }

  .right-block {
    width: 45%;
  }

  .one-half {
    // display: flex;
    display: inline-block;
  }

  .wine,
  .chart {
    position: absolute;
    width: 16%;
  }

  .wine {
    left: 18%;
    top: 20%;
  }

  .chart {
    left: 41%;
    top: 22%;
  }

  .people-bg {
    position: absolute;
    width: 46%;
    height: 100%;
    right: 0;
    top: 0;
  }

  @media #{$mobile} {
    height: 74rem;
    .text-block {
     &.one {
        text-align: center;
        position: relative;
        left: auto;
     }

     &.two {
      left: 31%;
      top: 16%;
      width: 31%;
     }
    }

    .people-bg {
      width: 36%;
      padding-top: 15rem;
    }

    .text-block-small {
      display: block;
    }

    .left-block,
    .right-block {
      width: 100%;
    }

    .wine {
      left: 11%;
      width: 16%;
    }

    .chart {
      top: 55%;
      left: 8%;
      width: 18%;
    }

    .left-block { 
      &:after { display: none; }
    }

    .right-block {
      width: 97%;
    }
  }
}
</style>
